import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Box, ButtonBase, InputBase, makeStyles, TextField } from '@material-ui/core';
import _, { debounce, isObject, isString, isArray, isFunction } from 'lodash';
import { useSelector } from 'react-redux';
import { AutoCompleteSelect } from '../../../../components';
import DiaLog from '../../../../components/Dialog';
import { DropDownIcon, DropUpIcon, ScanIcon } from '../../../../components/Icon';
import { equipmentAPI } from '../../../../apis';
import {
  EQUIPMENT_LENGTH,
  EQUIPMENT_PIE_STATUS_ENUM,
  EQUIPMENT_STATUS_ENUM,
  REMARKS_FIELD,
} from '../../../../comm/constant';
import { i18n } from '../../../../language';
import AutoCompleteInput from '../../../../components/AutoCompleteInput';
import StyleButton from '../../../../components/StyleButton';
import { useScanPage } from '../../../../utils/useScanQrcode';
import useMobile from '../../../../utils/useMobile';
import {
  DWP_COMM_REMARK_BMS_ISFA,
  DWP_COMM_REMARK_BMS_L,
  DWP_COMM_REMARK_BMS_M,
  DWP_COMM_REMARK_BMS_S,
} from '../../../../comm/commandQRcode';
import useBarcodeListener from '../../../../utils/useBarcodeListener';
import { handleScanHkid, handleScanPatientQrCode } from '../../ViewRequestTab/NewLoanRequestDialog';
import SingleADSDialog from '../../ViewRequestTab/ADS/SingleADSDialog';
import useGetRemarksListAPI from '../../hooks/useGetRemarksListAPI';
// import AddRemarks from '../../../../components/AddRemarks';
import { onKeyUpEnterOrSpace, useGetUserInfo } from '../../../../utils';
const useStyles = makeStyles(() => ({
  root: {},
  textTitle: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#7d86a9',
    marginBottom: '0.25rem',
  },
  inputTitle: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#7d86a9',
    marginBottom: '1rem',
  },
  assetId: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.313rem',
    color: '#1973e6',
  },
  statusIcon: {
    width: '0.625rem',
    height: '0.625rem',
    minWidth: '0.625rem',
    minHeight: '0.625rem',
    borderRadius: '50%',
    marginRight: '0.625rem',
  },
  resetIcon: {
    fontSize: '1.1rem',
    color: '#538FFF',
    marginRight: '0.5rem',
  },
  statusText: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
  },
  otherInfomation: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.125rem',
    color: '#3e3e3e',
    display: 'flex',
    padding: '1.063rem 0.719rem',
    borderTop: 'solid 1px #e6e7e8',
    borderBottom: 'solid 1px #e6e7e8',
    cursor: 'pointer',
  },
  dropDownButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '1.5rem',
    height: '1.5rem',
    marginRight: '1.25rem',
  },
  dropDownIcon: {
    fontSize: '0.938rem',
    color: '#3e3e3e',
  },
  inputBase: ({ error }) => ({
    border: error ? 'solid 1px #f44336' : 'solid 1px #e4e7eb',
    borderRadius: '10px',
    padding: '0.7rem 1.25rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
    '&.Mui-disabled': {
      backgroundColor: '#f5f5f5',
      color: '#2e4469',
    },
  }),
  errorMsg: {
    color: '#f44336',
    margin: '0.5rem 0.5rem 0',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
  },
  star: {
    color: '#ff0300',
  },
  confirmDialog: {
    '& .MuiPaper-root': {
      backgroundColor: '#FFFFFF',
      padding: '1.875rem',
      display: 'flex',
      overflowY: 'auto',
      flexDirection: 'column',
      borderRadius: '0.9375rem',
      boxShadow: '0 -0.125rem 1.3125rem rgba(30, 56, 140, 0.18)',
      alignItems: 'center',
    },
  },
  h1: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.5rem',
    color: '#2e4469',
  },
  closeIcon: {
    fontSize: '1.375rem',
    color: '#538fff',
  },
  buttonBase: {
    width: '1.5rem',
    height: '1.5rem',
  },
  textField: {
    borderRadius: '0.625rem',
    border: 'solid 1px #e4e7eb',
    padding: '0 1rem',
    '& .MuiInputBase-root': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      color: '#2e4469',
      lineHeight: '1.8rem',
    },
    '& :before': {
      content: 'none',
    },
    '& :after': {
      content: 'none',
    },
  },
  scanButton: {
    marginBottom: '0.25rem',
    flexBasis: '66%',
  },
  scanIcon: {
    color: '#538fff',
  },
  title: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#7d86a9',
  },
  confirmContent: {
    color: '#2e4469',
    fontSize: '1rem',
  },
  checkBox: {
    marginRight: '0',
    '& .MuiCheckbox-root': {
      color: '#c0c6cb',
    },
    '& .MuiTypography-root': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      fontWeight: '500',
      color: '#2e4469',
    },
    '& .Mui-checked': {
      color: '#28d2ab',
    },
  },
}));

const InputEquipment = ({
  value,
  onChange,
  placeholder,
  style,
  maxLength,
  check,
  error,
  errorMsg,
  disabled = false,
}) => {
  const classes = useStyles({ error });
  const [inputValue, setInputValue] = useState(value);
  useEffect(() => {
    setInputValue(value);
  }, [value]);

  // 防抖函數
  const debouncedSearch = useRef(
    debounce(async (props) => {
      onChange(props);
      check(props);
    }, 1000)
  ).current;

  // 清除副作用
  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  // input 的 onChange 事件
  const changeHandler = useCallback(
    (event) => {
      setInputValue(event.target.value);
      check ? debouncedSearch(event.target.value) : onChange(event.target.value);
    },
    [onChange, debounce]
  );

  return (
    <>
      <InputBase
        className={classes.inputBase}
        value={check ? inputValue : value}
        onChange={changeHandler}
        placeholder={placeholder}
        style={style}
        inputProps={{ maxLength }}
        disabled={disabled}
      />
      {error && <div className={classes.errorMsg}>{errorMsg}</div>}
    </>
  );
};

const TitleInput = ({
  title,
  placeholder,
  flexBasis,
  value,
  onChange,
  endAdornment,
  enterHandler,
  onFocus,
  onBlur,
  length = 'unset',
  error,
  errorMsg,
  disabled = false,
  id,
  isRequired = false,
}) => {
  const classes = useStyles({ error });

  const inputHandler = (event) => {
    if (isFunction(onChange)) {
      onChange(event.target.value);
    }
  };

  return (
    <Box display="flex" flexDirection="column" flexBasis={flexBasis}>
      <div className={classes.title}>
        {title}
        {isRequired && <span className={classes.star}> *</span>}
      </div>
      <InputBase
        id={id}
        className={classes.inputBase}
        placeholder={placeholder}
        style={{ width: '100%', marginTop: '1.063rem' }}
        onChange={inputHandler}
        value={value}
        endAdornment={endAdornment}
        // onKeyDown={onKeyDownHandler}
        onFocus={onFocus}
        onBlur={onBlur}
        inputProps={{ maxLength: length }}
        disabled={disabled}
      />
      {error && <div className={classes.errorMsg}>{i18n.t(errorMsg)}</div>}
    </Box>
  );
};

const replaceStrBmss = DWP_COMM_REMARK_BMS_S;
const replaceStrBmsm = DWP_COMM_REMARK_BMS_M;
const replaceStrBmsl = DWP_COMM_REMARK_BMS_L;
const replaceStrBmsIsfa = DWP_COMM_REMARK_BMS_ISFA;

const replaceHandler = (oldReplaceValue, newReplaceValue, value, enter, temp) => {
  const reg = new RegExp(oldReplaceValue, 'g');
  let str;
  if (value.target) {
    str = value.target.value.replace(reg, newReplaceValue);
  } else if (enter) {
    str = `${temp.remark + value.replace(reg, newReplaceValue)}\n`;
  } else {
    str = `${temp.remark + value.replace(reg, newReplaceValue)}`;
  }

  return str;
};

const judgeConstantRemark = (val, constantRemark) => val.indexOf(constantRemark) !== -1;

const handleInputRemark = ({ value, setFormData, enter }) => {
  setFormData((preData) => {
    let temp = { ...preData };
    let val = value.target ? value.target.value : value;

    if (judgeConstantRemark(val, replaceStrBmss)) {
      val = replaceHandler(replaceStrBmss, REMARKS_FIELD.BIPAP_MASK_SIZE_S, value, enter, temp);
    } else if (judgeConstantRemark(val, replaceStrBmsm)) {
      val = replaceHandler(replaceStrBmsm, REMARKS_FIELD.BIPAP_MASK_SIZE_M, value, enter, temp);
    } else if (judgeConstantRemark(val, replaceStrBmsl)) {
      val = replaceHandler(replaceStrBmsl, REMARKS_FIELD.BIPAP_MASK_SIZE_L, value, enter, temp);
    } else if (judgeConstantRemark(val, replaceStrBmsIsfa)) {
      val = replaceHandler(replaceStrBmsIsfa, REMARKS_FIELD.EXCEPT_ISOLATION_WARD, value, enter, temp);
    } else if (val.indexOf(REMARKS_FIELD.START_CODE) !== -1 && val.indexOf(REMARKS_FIELD.END_CODE) !== -1) {
      if (enter) {
        val = temp.remark + val.replace(REMARKS_FIELD.REPLACE_REMARK_REGEX, (value) => `${value.slice(13, -12)}\n`);
      } else {
        val = value.target
          ? val.replace(REMARKS_FIELD.REPLACE_REMARK_REGEX, (value) => value.slice(13, -12))
          : temp.remark + val.replace(REMARKS_FIELD.REPLACE_REMARK_REGEX, (value) => value.slice(13, -12));
      }
    }

    temp.remark = val;
    return { ...temp };
  });
};

const EditEquipment = ({ closeHandler, assetId, editSuccessHandler }) => {
  const classes = useStyles();
  const [otherInformationOpen, setOtherInformationOpen] = useState(true);
  const [data, setData] = useState({});
  const [itemData, setItemData] = useState({});
  const [formData, setFormData] = useState({
    assetId,
    brand: '',
    localCode: '',
    model: '',
    remark: '',
    reminderDuration: 14,
    status: null,
    patientNo: '',
    loanId: '',
    provideWardId: null,
    categorySatelliteStoresId: 0,
  });
  const loginInfo = useSelector((state) => state.loginInfo);
  const [errors, setErrors] = useState({
    localCode: '',
    patientNo: '',
  });
  const [equipmentStatus, setEquipmentStatus] = useState();
  const [confirmPop, setConfirmPop] = useState(false);
  const [isPad] = useMobile();
  const inputRef = useRef(null);
  const [barcodeListener, setBarcodeListener] = useState(true);
  const [serviceTypeList, setServiceTypeList] = useState([]);
  const [adsPopup, setAdsPopup] = useState(false);
  const userInfo = useGetUserInfo();
  const adsRef = useRef(null);
  const [currentLocation, setCurrentLocation] = useState('');

  // 原始status
  const [oldState, setOldState] = useState('');
  // 原始 status 不是黄色状态的时候才可以修改
  const disabledCurrentLocation = _.some([2, 3, 4, 5], (item) => item === oldState);
  const [currentLocationOptions, setCurrentLocationOptions] = useState([]);
  const { remarkList: activeRemarkList, getRemarksListAPI } = useGetRemarksListAPI();

  const otherInformationController = useCallback(() => {
    setOtherInformationOpen((preValue) => !preValue);
  }, []);
  // 从api返回的EquipmentInfo获取location
  const getLocationValFromEquipmentInfo = (info) => {
    if (info?.returnDesignateRoom) {
      return info?.returnDesignateRoom;
    } else {
      return !disabledCurrentLocation && info?.categorySatelliteStoresId
        ? `${info?.wardId}-${info?.categorySatelliteStoresId}`
        : info?.wardId;
    }
  };

  // 獲取detail
  const getPatientEquipmentAPI = useCallback(async () => {
    try {
      const { result } = await equipmentAPI.getPatientEquipment({ assetId });
      setData(result);
      setFormData({
        assetId,
        brand: result?.brand ?? '',
        localCode: result?.localCode ?? '',
        model: result?.model ?? '',
        remark: result?.remark ?? '',
        reminderDuration: result?.reminderDuration ?? 0,
        status: result?.status ?? null,
        patientNo: result?.patientNo ?? '',
        loanId: result?.loanId ?? '',
        provideWardId: result?.provideWardId ?? '',
        categorySatelliteStoresId: result?.categorySatelliteStoresId,
      });
      setOldState(result?.status ?? null);
      setCurrentLocation(getLocationValFromEquipmentInfo(result));
      const response = await equipmentAPI.getEquipmentStatus({
        wardId: loginInfo.wardId,
        currentStatus: result.status,
        assetId: result.assetId,
      });
      setEquipmentStatus(response.result.status);
    } catch (error) {
      console.log(error);
    }
  }, [assetId, loginInfo, disabledCurrentLocation]);

  const handleChangeStatus = useCallback(
    (value) => {
      const equipmentLocationVal = getLocationValFromEquipmentInfo(data);
      if ([2, 3, 4, 5].includes(data?.status)) {
        const newCurrentLocationOptions = _.map(currentLocationOptions, (item) => {
          // 如果转的状态是 1 或 10, 修改当前location的text为data.returnCurrentLocation,
          // 不是1 或 10或者 returnCurrentLocation=null 都用回原来的
          // 如果api有返回roomName,要把roomName拼上
          const textWithRoomName = `${data?.wardName}${data?.roomName ? `-${data?.roomName}` : ''}`;
          if (item?.value === equipmentLocationVal) {
            return {
              ...item,
              text: [1, 10].includes(value) ? data?.returnCurrentLocation ?? textWithRoomName : textWithRoomName,
            };
          }
          return item;
        });
        setCurrentLocationOptions(newCurrentLocationOptions);
      }

      setFormData((preData) => ({
        ...preData,
        status: value,
      }));
    },
    [data]
  );

  // 處理表單數據
  const formHandler = useCallback(
    (type, enter) => (value) => {
      if (type === 'remark') {
        handleInputRemark({ value, setFormData, enter });
      } else if (type === 'patientNo') {
        setFormData((preData) => {
          let newValue = value.replace(/^\s*/, '');
          if (newValue.startsWith('HN') || newValue === '' || newValue.startsWith('WB')) {
            setErrors((preErrors) => ({
              ...preErrors,
              patientNo: '',
            }));
          } else {
            setErrors((preErrors) => ({
              ...preErrors,
              patientNo: 'EQUIPMENT_VIEWREQUEST_PATIENT_ERROR_MSG',
            }));
          }

          return { ...preData, [type]: newValue };
        });
      } else if (type === 'status') {
        handleChangeStatus(value);
      } else {
        setFormData((preData) => ({
          ...preData,
          [type]: value,
        }));
      }
    },
    [handleChangeStatus]
  );

  useEffect(() => {
    (async () => {
      await getPatientEquipmentAPI();
    })();
  }, [getPatientEquipmentAPI]);
  const dataMemo = useMemo(() => {
    if (!data) {
      return {
        statusText: '',
        statusColor: '#fff',
        providerValue: '',
        providerItems: [],
        currentLocationValue: '',
        currentLocationItems: [],
        patientValue: '',
        patientItems: [],
        categoryValue: '',
        categoryItems: [],
      };
    }
    // status
    let tempStatus = _.find(EQUIPMENT_STATUS_ENUM, (item) => item.enumKey === data.status);
    let statusText = tempStatus?.textKey;
    let statusColor = tempStatus?.color;
    // provider
    let providerValue = data.provideWardId;
    let providerItems = [
      {
        text: data.satelliteStoresName ? `    ${data.satelliteStoresName}` : data.provideWardName,
        value: data.provideWardId,
      },
    ];

    // current location
    let currentLocationValue = data.wardId;

    let currentLocationItems = [{ text: data.wardName, value: data.wardId, categorySatelliteStoresId: null }];
    if (data?.returnDesignateRoom) {
      currentLocationValue = data?.returnDesignateRoom;
      currentLocationItems.unshift({
        text: data?.returnDesignateRoom,
        value: data?.returnDesignateRoom,
        categorySatelliteStoresId: data?.categorySatelliteStoresId ?? null,
        returnDesignateRoom: data?.returnDesignateRoom,
      });
    }

    // Patient HN
    let patientValue = data?.patientNo ?? '';
    let patientItems = [{ text: patientValue, value: patientValue }];

    // category
    let categoryValue = data.categoryId;
    let categoryItems = [{ text: data.categoryName, value: data.categoryId }];

    return {
      statusText,
      statusColor,
      providerValue,
      providerItems,
      currentLocationValue,
      currentLocationItems,
      patientValue,
      patientItems,
      categoryValue,
      categoryItems,
    };
  }, [data]);

  // satellite store options
  const serviceTypeOptions = useMemo(() => {
    return serviceTypeList
      .filter((item) => item.hospitalCategoryId === dataMemo.categoryValue)
      .map((item) => ({
        text: `    ${item.satelliteStoresName}`,
        value: `${data?.wardId}-${item.categorySatelliteStoresId}`,
        categorySatelliteStoresId: item.categorySatelliteStoresId,
      }));
  }, [serviceTypeList, dataMemo.categoryValue, data?.wardId]);
  useEffect(() => {
    let locationOptions = _.concat(dataMemo.currentLocationItems, serviceTypeOptions);
    // 如果当前设备是借出去的状态,并且api有返回roomName的话就要拼上roomName显示
    if ([2, 3, 4, 5].includes(data?.status)) {
      locationOptions = _.map(locationOptions, (locItem) => {
        if (locItem?.value === currentLocation) {
          return { ...locItem, text: `${locItem?.text}${data?.roomName ? `-${data?.roomName}` : ''}` };
        } else {
          return locItem;
        }
      });
    }
    setCurrentLocationOptions(locationOptions);
  }, [dataMemo.currentLocationItems, serviceTypeOptions, dataMemo.status, currentLocation]);

  // 当前选择的location 里面的satellite store
  const categorySatelliteStoresId = useMemo(() => {
    return _.get(
      _.find(currentLocationOptions, (item) => item.value === currentLocation),
      'categorySatelliteStoresId'
    );
  }, [currentLocationOptions, currentLocation]);

  // 獲取 brand && model list
  const getEquipmentModelAPI = useCallback(async () => {
    try {
      if (!data?.categoryId) {
        return;
      }
      const { result } = await equipmentAPI.getEquipmentModel({ categoryId: data.categoryId });
      setItemData(result);
    } catch (error) {
      console.log(error);
    }
  }, [data?.categoryId]);

  useEffect(() => {
    (async () => {
      await getEquipmentModelAPI();
    })();
  }, [getEquipmentModelAPI]);

  // 處理 itemList 的數據
  const itemListOptions = useMemo(() => {
    let brand = [];
    let model = [];

    if (isObject(itemData)) {
      brand = _.map(
        _.filter(itemData.brand, (brandItem) => isString(brandItem)),
        (item) => ({
          text: item,
          value: item,
        })
      );

      model = _.map(
        _.filter(itemData.model, (modelItem) => isString(modelItem)),
        (item) => ({
          text: item,
          value: item,
        })
      );
    }

    return {
      brand,
      model,
    };
  }, [itemData]);

  // 提交修改
  const submitHandler = async ({ adsCategoryId = null, isAdsServer = null, instCode = null, loanType = null }) => {
    try {
      const currentLocationObject = currentLocationOptions.find((item) => item.value === currentLocation);
      await equipmentAPI.editEquipment({
        ...formData,
        adsCategoryId,
        instCode,
        isAdsServer,
        loanType,
        transferSatelliteStoresId: categorySatelliteStoresId,
        returnDesignateRoom: currentLocationObject?.returnDesignateRoom ?? null,
      });
      editSuccessHandler();
    } catch (error) {
      console.log(error);
    }
  };

  const confirmPopHandler = useCallback((props) => () => {
    setConfirmPop(props);
  });

  const confirmBtn = async () => {
    const isCSSD = Boolean(data?.returnDesignateRoom);
    // CSSD的时候还回去
    const isCssdReturnSatelliteStore = isCSSD && data.categorySatelliteStoresId === categorySatelliteStoresId;
    // 状态从2,3,4,5 转 1,10的时候不用发ads
    const doNotShowAds = [2, 3, 4, 5].includes(data?.status) && [1, 10].includes(formData?.status);
    if ((data.categorySatelliteStoresId !== categorySatelliteStoresId || isCssdReturnSatelliteStore) && !doNotShowAds) {
      setAdsPopup(true);
      adsRef?.current?.getAdsLocation?.();
    } else {
      await submitHandler({});
    }
  };

  const submitHandlerBtn = () => {
    // multipleEquipment为0弹出pop-up， 为1则不用弹
    if (data?.multipleEquipment === 0) {
      confirmPopHandler(true)();
    } else {
      confirmPopHandler(false)();
      confirmBtn();
    }
  };

  // check local code
  const checkLocalCode = useCallback(
    async (localCode) => {
      try {
        if (localCode) {
          const { result } = await equipmentAPI.checkLocalCode(
            {
              hospitalId: loginInfo.hospitalId,
              localcode: localCode,
            },
            { isHideLoading: true }
          );

          if (result === 'success') {
            setErrors((preErrors) => ({ ...preErrors, localCode: '' }));
            return;
          } else {
            setErrors((preErrors) => ({
              ...preErrors,
              localCode: i18n.t('EQUIPMENT_MANAGE_REGISTER_LOCAL_CODE_ERROR'),
            }));
          }
        } else {
          setErrors((preErrors) => ({ ...preErrors, localCode: '' }));
        }
      } catch (error) {
        console.log(error);
      }
    },
    [loginInfo, formData]
  );

  // status  dropdown
  const optionsMemo = useMemo(() => {
    let options = {
      status: [],
    };
    let tempStatus = _.find(EQUIPMENT_STATUS_ENUM, (item) => item.enumKey === data?.status);
    let text = tempStatus?.textKey ? i18n.t(tempStatus.textKey) : '';
    let value = tempStatus?.enumKey;
    if (isArray(equipmentStatus)) {
      options.status = _.map(equipmentStatus, (item) => ({
        text: i18n.t(_.find(EQUIPMENT_PIE_STATUS_ENUM, (statusItem) => statusItem.enumKey === item.id)?.textKey),
        value: item.id,
      }));
    }
    options.status.unshift({ text: text, value: value });

    return options;
  }, [equipmentStatus]);

  // Patient HN Read Only
  const patientHNDisabled = useMemo(() => {
    let patientHNReadOnly = false;
    switch (formData.status) {
      case 1:
      case 6:
      case 7:
      case 8:
      case 9:
      case 10:
        patientHNReadOnly = true;
        break;
      default:
        break;
    }
    return patientHNReadOnly;
  }, [formData.status]);

  // confirm button disable
  const confirmDisable = useMemo(() => {
    return !formData.patientNo.replace(/\s*/g, '').startsWith('HN') && !patientHNDisabled;
  }, [formData.patientNo, patientHNDisabled]);

  const [ScanPortalRemarks, openScanPageRemarks] = useScanPage(formHandler('remark', true));
  // Patient HN
  const [ScanPortalPatientHN, openScanPagePatientHN] = useScanPage(handleScanPatientQrCode(formHandler('patientNo')));

  // 監聽 barcode 槍 remarks
  useBarcodeListener((e) => {
    if (e.replace(/\s*/g, '').startsWith('HN') && !patientHNDisabled) {
      formHandler('patientNo')(e.replace(/\s*/g, ''));
    } else if (e.toUpperCase().startsWith('WB ') && !patientHNDisabled) {
      handleScanHkid(formHandler('patientNo'), () => {}, e);
      setOtherInformationOpen(true);
    } else {
      setOtherInformationOpen(true);
      inputRef.current.focus();
      formHandler('remark')(e);
    }
  }, barcodeListener);

  const getSatelliteStores = async () => {
    try {
      const { result } = await equipmentAPI.getSatelliteStores();
      setServiceTypeList(result);
    } catch (error) {
      console.log(error);
    }
  };

  // remark popup 选择
  const handleSelectRemark = (remark) => {
    setFormData((o = {}) => ({
      ...o,
      remark: `${o?.remark || ''} ${remark}`.slice(0, 99),
    }));
  };
  useEffect(() => {
    getSatelliteStores();
  }, []);

  useEffect(() => {
    if (data?.categoryId) {
      getRemarksListAPI({ hospitalCategoryIds: [data?.categoryId] });
    }
  }, [data?.categoryId]);

  return (
    <>
      {!confirmPop && (
        <DiaLog
          open={true}
          handleCancel={closeHandler}
          handleClose={closeHandler}
          handleConfirm={submitHandlerBtn}
          title={i18n.t('EQUIPMENT_MANAGE_EDIT_TITLE')}
          cancel={i18n.t('EQUIPMENT_MANAGE_EDIT_CANCEL')}
          confirm={i18n.t('EQUIPMENT_MANAGE_EDIT_CONFIRM')}
          dialogfootStyle={{ marginTop: '1rem' }}
          confirmStyle={{ backgroundColor: !confirmDisable && '#28d2ab' }}
          disabled={confirmDisable}
        >
          <ScanPortalRemarks />
          <ScanPortalPatientHN />
          <Box display="flex" justifyContent="space-between" gridColumnGap="1.5rem" mb="1.25rem">
            <Box display="flex" flexDirection="column" flexBasis="50%">
              <div className={classes.textTitle}>{i18n.t('EQUIPMENT_MANAGE_EDIT_ASSET_ID')}</div>
              <div className={classes.assetId}>{assetId}</div>
            </Box>
            <Box display="flex" flexDirection="column" flexBasis="50%">
              <div className={classes.textTitle}>{i18n.t('EQUIPMENT_MANAGE_EDIT_STATUS')}</div>
              {/* <Box display="flex" alignItems="center"> */}
              {/* <div className={classes.statusIcon} style={{ backgroundColor: dataMemo.statusColor }} />
              <div className={classes.statusText}>{dataMemo?.statusText ? i18n.t(dataMemo.statusText) : ''}</div> */}
              <AutoCompleteSelect
                placeholder={i18n.t('EQUIPMENT_VIEWREQUEST_NEW_REQUEST_PROVIDER_PLACEHOLDER')}
                width="100%"
                itemList={optionsMemo.status}
                value={formData.status}
                onChange={formHandler('status')}
              />
              {/* </Box> */}
            </Box>
          </Box>
          <Box display="flex" justifyContent="space-between" gridColumnGap="1.5rem" mb="1.25rem">
            <Box display="flex" flexDirection="column" flexBasis="50%">
              <div className={classes.inputTitle}>{i18n.t('EQUIPMENT_MANAGE_EDIT_PROVIDER')}</div>
              <AutoCompleteSelect itemList={dataMemo.providerItems} value={dataMemo.providerValue} disabled={true} />
            </Box>
            <Box display="flex" flexDirection="column" flexBasis="50%">
              <div className={classes.inputTitle}>{i18n.t('EQUIPMENT_MANAGE_EDIT_CURRENT_LOCATION')}</div>
              <AutoCompleteSelect
                itemList={currentLocationOptions}
                value={currentLocation}
                onChange={(value) => setCurrentLocation(value)}
                disabled={disabledCurrentLocation}
                whiteSpace
              />
            </Box>
          </Box>
          <Box display="flex" justifyContent="space-between" gridColumnGap="1.5rem" mb="1.25rem">
            <Box display="flex" flexDirection="column" width="50%" mb="1rem">
              {/* <div className={classes.inputTitle}>
                {i18n.t('EQUIPMENT_MANAGE_EDIT_PATIENT_HN')} <span className={classes.star}>*</span>
              </div> */}
              {/* <InputEquipment
                id="equipment-edit-input-pantientHN"
                value={formData.patientNo}
                onChange={formHandler('patientNo')}
                placeholder={i18n.t('EQUIPMENT_VIEWREQUEST_NEW_REQUEST_PATIENT_HN_PLACEHOLDER')}
              /> */}
              <TitleInput
                id="equipment-input-patient"
                title={i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_PATIENT_HN')}
                placeholder={i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_PATIENT_HN_PLACEHOLDER')}
                flexBasis="48%"
                endAdornment={
                  isPad ? (
                    <ButtonBase
                      id="equipment-button-patient"
                      onClick={() => {
                        (async () => {
                          await openScanPagePatientHN();
                        })();
                      }}
                      disabled={patientHNDisabled}
                    >
                      <ScanIcon className={classes.scanIcon} />
                    </ButtonBase>
                  ) : (
                    <div />
                  )
                }
                value={formData.patientNo}
                onChange={formHandler('patientNo')}
                length={EQUIPMENT_LENGTH.REQUEST_HN}
                onFocus={() => setBarcodeListener(false)}
                onBlur={() => setBarcodeListener(true)}
                error={Boolean(errors.patientNo)}
                errorMsg={errors.patientNo}
                disabled={patientHNDisabled}
                isRequired={!patientHNDisabled}
              />
            </Box>
            <Box display="flex" flexDirection="column" width="50%">
              <div className={classes.inputTitle}>{i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_ID')} </div>
              <InputEquipment
                id="equipment-edit-input-Request ID"
                value={formData.loanId}
                onChange={formHandler('requestID')}
                placeholder={i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_ID')}
                disabled={true}
              />
            </Box>
          </Box>
          <Box display="flex" flexDirection="column" width="100%" mb="1.5rem">
            <div className={classes.inputTitle}>{i18n.t('EQUIPMENT_MANAGE_EDIT_CATEGORY')}</div>
            <AutoCompleteSelect itemList={dataMemo.categoryItems} value={dataMemo.categoryValue} disabled={true} />
          </Box>
          <div
            id="equipment-register-button-otherinformation"
            className={classes.otherInfomation}
            onClick={otherInformationController}
            tabIndex={0}
            onKeyUp={(e) => onKeyUpEnterOrSpace(e, otherInformationController)}
          >
            <div className={classes.dropDownButton}>
              {otherInformationOpen ? (
                <DropUpIcon className={classes.dropDownIcon} />
              ) : (
                <DropDownIcon className={classes.dropDownIcon} />
              )}
            </div>
            {i18n.t('EQUIPMENT_MANAGE_EDIT_OTHER')}
          </div>
          {otherInformationOpen && (
            <Box display="flex" p="1.5rem 0" flexDirection="column" borderBottom="solid 1px #e6e7e8">
              <Box display="flex" flexDirection="column" width="100%" mb="1.5rem">
                <div className={classes.inputTitle}>{i18n.t('EQUIPMENT_MANAGE_EDIT_LOCAL_CODE')}</div>
                <InputEquipment
                  id="equipment-register-input-local"
                  value={formData.localCode}
                  onChange={formHandler('localCode')}
                  placeholder={i18n.t('EQUIPMENT_MANAGE_EDIT_LOCAL_CODE_PLACEHOLDER')}
                  check={checkLocalCode}
                  error={Boolean(errors.localCode)}
                  errorMsg={errors.localCode}
                />
              </Box>
              <Box display="flex" justifyContent="space-between" gridColumnGap="1.438rem" mb="1.5rem">
                <Box display="flex" flexDirection="column" width="50%">
                  <div className={classes.inputTitle}>{i18n.t('EQUIPMENT_MANAGE_EDIT_MODEL')}</div>
                  <AutoCompleteInput
                    id="equipment-register-autocomplete-model"
                    itemList={itemListOptions.model}
                    value={formData.model}
                    onChange={formHandler('model')}
                    placeholder={i18n.t('EQUIPMENT_MANAGE_EDIT_MODEL_PLACEHOLDER')}
                    freeSolo={true}
                  />
                </Box>
                <Box display="flex" flexDirection="column" width="50%">
                  <div className={classes.inputTitle}>{i18n.t('EQUIPMENT_MANAGE_EDIT_BRAND')}</div>
                  <AutoCompleteInput
                    id="equipment-register-autocomplete-brand"
                    itemList={itemListOptions.brand}
                    value={formData.brand}
                    onChange={formHandler('brand')}
                    placeholder={i18n.t('EQUIPMENT_MANAGE_EDIT_BRAND_PLACEHOLDER')}
                    freeSolo={true}
                  />
                </Box>
              </Box>
              {/* <LongLoanReminder value={formData.reminderDuration} onChange={formHandler('reminderDuration')} minNum={0} /> */}
              <Box display="flex" flexDirection="column" width="100%">
                {/* <InputEquipment
                  id="equipment-register-input-remark"
                  value={formData.remark}
                  onChange={formHandler('remark')}
                  placeholder={i18n.t('EQUIPMENT_MANAGE_EDIT_REMARK_PLACEHOLDER')}
                /> */}
                <Box display="flex" justifyContent="space-between" flexDirection="column" mb="1.313rem">
                  <Box display="flex" justifyContent="space-between">
                    <div className={classes.inputTitle}>{i18n.t('EQUIPMENT_MANAGE_EDIT_REMARK')}</div>
                    {/* <AddRemarks list={activeRemarkList} handleSelect={handleSelectRemark} /> */}
                  </Box>

                  <Box display="flex" gridColumnGap="1.5rem">
                    <TextField
                      id="equipment-register-input-remark"
                      className={classes.textField}
                      placeholder={i18n.t('EQUIPMENT_MANAGE_EDIT_REMARK_PLACEHOLDER')}
                      multiline={true}
                      fullWidth={true}
                      rows={4}
                      value={formData.remark}
                      onChange={formHandler('remark')}
                      inputRef={inputRef}
                      onFocus={() => setBarcodeListener(false)}
                      onBlur={() => setBarcodeListener(true)}
                    />
                    {isPad && (
                      <StyleButton
                        id="ViewRequest-button-scan-remark"
                        className={classes.scanButton}
                        width="14.125rem"
                        text={i18n.t('EQUIPMENT_VIEWREQUEST_NEW_REQUEST_SCAN_EQUIPMENT')}
                        Icon={ScanIcon}
                        iconStyle={{ fontSize: '1.5rem', marginRight: '0.75rem' }}
                        onClick={openScanPageRemarks}
                        style={{ marginTop: '1rem' }}
                      />
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>
          )}
        </DiaLog>
      )}
      {confirmPop && <UpdateConfirmPop confirmPopHandler={confirmPopHandler} confirmBtn={confirmBtn} />}
      <SingleADSDialog
        editEquipment
        handleNewRequest={({ adsCategoryId, isAdsServer }) =>
          submitHandler({
            adsCategoryId,
            instCode: userInfo.hospCode,
            isAdsServer,
            loanType: 'SATELLITESTORES',
          })
        }
        equipmentAssets={[
          {
            category: data.categoryId,
          },
        ]}
        formData={formData}
        adsPopup={adsPopup}
        handleClose={() => setAdsPopup(false)}
        adsType="new"
        adsWardInfo={{
          provider: formData.provideWardName,
          request: formData.wardName,
        }}
        ref={adsRef}
        provideWardId={data.provideWardId}
        requestWard={data.wardId}
        adsWardLocationId={data.adsWardLocationId}
        categorySatelliteStoresId={data.categorySatelliteStoresId}
        transferSatelliteStoresId={categorySatelliteStoresId}
        currentLocationText={_.get(
          _.find(currentLocationOptions, (item) => item.value === currentLocation),
          'text'
        )}
        assetId={assetId}
      />
    </>
  );
};
const UpdateConfirmPop = ({ confirmPopHandler, confirmBtn }) => {
  const classes = useStyles();
  const confirmUpdateBtn = useCallback(() => {
    confirmBtn();
  }, [confirmBtn]);
  return (
    <DiaLog
      title={i18n.t('EQUIPMENT_CONFIRM_TITLE')}
      cancel={i18n.t('EQUIPMENT_CONFIRM_CANCEL')}
      confirm={i18n.t('EQUIPMENT_CONFIRM_OK')}
      open={true}
      handleCancel={confirmPopHandler(false)}
      handleClose={confirmPopHandler(false)}
      handleConfirm={confirmUpdateBtn}
    >
      <div className={classes.confirmContent}> {i18n.t('EQUIPMENT_CONFIRM_TEXT')}</div>
    </DiaLog>
  );
};
export default EditEquipment;
